import { useNavigate } from "@tanstack/react-router";
import { useSelectTeamMembers } from "../api/selectTeamMembers";
import { useSelectSecretaryOrganisations } from "../api/selectSecretaryOrganisations";
import TeamTable from "./TeamTable";
import { TeamTableSkeleton } from "./TeamTableSkeleton";
import { commonComponents as cc } from "@/components/common";
import { useProfileCopy } from "@/features/i18n/profileCopy";
import { useAuth } from "@/utils/auth";

const TeamPage = () => {
    const copy = useProfileCopy();
    const auth = useAuth();
    const navigate = useNavigate();
    const { data, isLoading } = useSelectTeamMembers();
    const { data: secretaryAssignments = [] } = useSelectSecretaryOrganisations(auth.id);

    const { members, currentUserOrganisations } = data || {
        members: [],
        currentUserOrganisations: [],
    };

    return (
        <section className="space-y-6 w-full min-w-0">
            <cc.AppPageHeader
                title={copy.myTeam}
                description={copy.teamPageDescription}
                actions={
                    <cc.AppListActionButton
                        label={copy.inviteUser}
                        data-testid="team-invite-user"
                        layout="desktop"
                        onClick={() => navigate({ to: "/team/invite" })}
                    />
                }
            />

            {isLoading ? (
                <TeamTableSkeleton />
            ) : (
                <TeamTable
                    members={members}
                    currentUserOrganisations={currentUserOrganisations}
                    secretaryAssignments={secretaryAssignments}
                />
            )}
        </section>
    );
};

export default TeamPage;
